module.exports = __webpack_public_path__ + "media/images/property_photo5-1ed6aa63.jpg";